import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ImageCarousel.css';

const ImageCarousel = () => {
    const settings = {
        dots: false,           // Muestra los puntos de navegación
        infinite: true,       // Permite navegar de manera infinita
        speed: 800,           // Velocidad de transición entre imágenes
        slidesToShow: 3,      // Cuántas imágenes mostrar a la vez en pantallas grandes
        slidesToScroll: 3,    // Cuántas imágenes desplazar con un scroll en pantallas grandes
        arrows: true,         // Habilita las flechas de navegación
        autoplay: false,      // Desactiva el autoplay para control manual
        fade: false,          // Quita el efecto de desvanecimiento
        responsive: [
          {
            breakpoint: 768,  // Para pantallas menores a 768px (móviles y tablets)
            settings: {
              slidesToShow: 1, // Mostrar solo una imagen en móviles
              slidesToScroll: 1 // Desplazar una imagen a la vez
            }
          }
        ]
      };

  return (
    <div className="image-carousel">
      <Slider {...settings}>
        <div>
          <img src="/img/admin2.png" alt="Slide 1" className="common-image"/>
        </div>
        <div>
          <img src="/img/venta2.png" alt="Slide 2" className="common-image"/>
        </div>
        <div>
          <img src="/img/deposito2.png" alt="Slide 3" className="common-image"/>
        </div>
        <div>
          <img src="/img/admin3.png" alt="Slide 1" className="common-image"/>
        </div>
        <div>
          <img src="/img/venta3.png" alt="Slide 2" className="common-image"/>
        </div>
        <div>
          <img src="/img/deposito3.png" alt="Slide 3" className="common-image"/>
        </div>
        <div>
          <img src="/img/admin.png" alt="Slide 1" className="common-image"/>
        </div>
        <div>
          <img src="/img/funciones.png" alt="Slide 2" className="common-image"/>
        </div>
        <div>
          <img src="/img/deposito.png" alt="Slide 3" className="common-image"/>
        </div>
        <div>
          <img src="/img/admin7.png" alt="Slide 1" className="common-image"/>
        </div>
        <div>
          <img src="/img/venta7.png" alt="Slide 2" className="common-image"/>
        </div>
        <div>
          <img src="/img/deposito7.png" alt="Slide 3" className="common-image"/>
        </div>
        <div>
          <img src="/img/admin5.png" alt="Slide 1" className="common-image"/>
        </div>
        <div>
          <img src="/img/venta5.png" alt="Slide 2" className="common-image"/>
        </div>
        <div>
          <img src="/img/deposito5.png" alt="Slide 3" className="common-image"/>
        </div>
        <div>
          <img src="/img/admin6.png" alt="Slide 1" className="common-image"/>
        </div>
        <div>
          <img src="/img/venta6.png" alt="Slide 2" className="common-image"/>
        </div>
        <div>
          <img src="/img/deposito6.png" alt="Slide 3" className="common-image"/>
        </div>
      </Slider>
    </div>
  );
};

export default ImageCarousel;


